export interface SelectOption {
  label: string;
  value: string | boolean | number;
}

export const formeJuridique = [
    { label: 'EARL', value: 'EARL' },
    { label: 'Commerçant', value: 'CO' },
    { label: 'EI', value: 'EI' },
    { label: 'EURL', value: 'EURL' },
    { label: 'GIE', value: 'GIE' },
    { label: 'SA', value: 'SA' },
    { label: 'SARL', value: 'SARL' },
    { label: 'SAS', value: 'SAS' },
    { label: 'SASU', value: 'SASU' },
    { label: 'SC', value: 'SC' },
    { label: 'SCA', value: 'SCA' },
    { label: 'SCI', value: 'SCI' },
    { label: 'SCM', value: 'SCM' },
    { label: 'SCOP', value: 'SCOP' },
    { label: 'SCP', value: 'SCP' },
    { label: 'SCS', value: 'SCS' },
    { label: 'SELRL', value: 'SELRL' },
    { label: 'SNC', value: 'SNC' },
    { label: 'SAEM', value: 'SAEM' },
    { label: 'ETS', value: 'ETS' },
    { label: 'EIRL', value: 'EIRL' },
] as SelectOption[];

export const titulaireCarteGriseOptions = [
    { label: 'La société', value: '2' },
    { label: 'Vous-même', value: '1' },
    { label: 'Autre', value: '3' },
] as SelectOption[];

export const booleanOptions = [
    { label: 'Oui', value: true },
    { label: 'Non', value: false },
] as SelectOption[];

export const SIGNATURE_METHOD_OPTIONS: SelectOption[] = [
  { label: 'SMS', value: 'sms' },
  { label: 'Email', value: 'email' },
];

export const CIVILITE_OPTIONS = [
  { label: 'Monsieur', value: '0' },
  { label: 'Madame', value: '1' },
];

export const DEBUT_CONTRAT_OPTIONS = [
  { label: 'Maintenant', value: '0' },
  { label: 'Un autre jour', value: '1' },
];

export const OUI_NON_OPTIONS = [
  { label: 'Oui', value: true },
  { label: 'Non', value: false },
];

export const OUI_NON_INTEGER_OPTIONS = [
    { label: 'Oui', value: 1 },
    { label: 'Non', value: 0 },
];

// Options pour DevoirConseil (API attend des strings)
export const OUI_NON_STRING_OPTIONS = [
    { label: 'Oui', value: '1' },
    { label: 'Non', value: '0' },
];

// Options spécifiques pour DevoirUsage
export const OUI_NON_DEVOIR_USAGE_OPTIONS = [
    { label: 'Oui', value: '2' },
    { label: 'Non', value: '1' },
];

export const RELATIONSHIP_OPTIONS = [
    { value: 'C', label: 'Conjoint' },
    { value: 'E', label: 'Enfant' },
    { value: 'FS', label: 'Frère/Sœur' },
    { value: 'GP', label: 'Grand-parent' },
    { value: 'P', label: 'Parent' },
    { value: 'A', label: 'Autres' },
];
